import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AngularSplitModule} from 'angular-split';
import {EtsSymbolPickerModule} from '../symbol-picker/symbol-picker.module';
import {GenericConfirmationDialogModule} from '../generic-confirmation-dialog/generic-confirmation-dialog.module';
import {EtsCommonModule} from '../common-services/common.module';
import {DevExtremeModule} from '../devextreme.module';
import {OptionsCommonModule} from '../options-common/options-common.module';
import {PortfolioHedgingAnalysisPanelComponent} from './portfolio-hedging-analysis-panel.component';
import {PhaUnderlyingsTableComponent} from './pha-underlyings-table.component';
import {PhaPremiumTableComponent} from './pha-premium-table.component';
import {PhaProtectionTableComponent} from './pha-protection-table.component';
import {PhaAddItmCallDialogComponent} from './pha-add-itm-call-dialog.component';
import {PhaHedgeProductsDialogComponent} from './pha-hedge-products-dialog.component';
import {PhaBenchmarkDialogComponent} from './pha-benchmark-dialog.component';
import {PhaExportDialogModule} from './pha-export-dialog.module';

// CR-20260929-001 — the Portfolio Hedging Analysis panel. Eager like every panel module: declare
// NO stateful providers here (they would hoist to the root injector and be shared across panel
// instances — the Maven lesson); per-panel services go on the panel component's `providers`.
@NgModule({
    imports: [
        CommonModule,
        DevExtremeModule,
        OptionsCommonModule,
        AngularSplitModule,
        EtsSymbolPickerModule,
        GenericConfirmationDialogModule,
        // The 'etsFriendlyDatePipe' the panel's After State tables use.
        EtsCommonModule,
        // The Export window (shared with the Portfolio Hedging panel's acquire mode, M3).
        PhaExportDialogModule
    ],
    declarations: [
        PortfolioHedgingAnalysisPanelComponent,
        PhaUnderlyingsTableComponent,
        PhaPremiumTableComponent,
        PhaProtectionTableComponent,
        PhaAddItmCallDialogComponent,
        PhaHedgeProductsDialogComponent,
        PhaBenchmarkDialogComponent
    ],
    exports: [
        PortfolioHedgingAnalysisPanelComponent
    ]
})
export class PortfolioHedgingAnalysisModule {
}
